import type { ReactNode } from "react";
import AppSlideOver from "./AppSlideOver";

type Props = {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  children: ReactNode;
};

/**
 * Full-bleed create/edit host for large editors (anomaly definition, widget, query).
 * Starts fullscreen-capable at xl width with the standard fullscreen toggle.
 */
export default function EditorSlideOver({ open, onClose, title, children }: Props) {
  return (
    <AppSlideOver open={open} onClose={onClose} title={title} size="xl" defaultFullscreen>
      {open ? children : null}
    </AppSlideOver>
  );
}
